export const portfolioKeys = {
  all: ['portfolio'] as const,
  profile: () => [...portfolioKeys.all, 'profile'] as const,
  siteContent: () => [...portfolioKeys.all, 'site-content'] as const,
  skills: () => [...portfolioKeys.all, 'skills'] as const,
  education: () => [...portfolioKeys.all, 'education'] as const,
  awards: () => [...portfolioKeys.all, 'awards'] as const,
  certifications: () => [...portfolioKeys.all, 'certifications'] as const,
  projects: () => [...portfolioKeys.all, 'projects'] as const,
  experience: () => [...portfolioKeys.all, 'experience'] as const,
};
